import { render, staticRenderFns } from "./MiniBanners.vue?vue&type=template&id=7f2e4a6b"
import script from "./MiniBanners.vue?vue&type=script&lang=js"
export * from "./MiniBanners.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports